














































































import Vue from "vue";
import CarreraService from "@/api/CarreraService";
import { AxiosError } from "axios";

//import moment from "moment";
export default Vue.extend({
  components: {},
  props: ["dialog", "carreraID"],
  data() {
    return {
      valid: true,
      files: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        link: "",
        tipo: "",
        posicion: 1
      },
      /*
      imageRules: [
        (value: File) =>
          !value || value.size < 2000000 || "Imagen debe pesar menos de 2 MB!"
      ],
      */
      imageRules: [
        (value: File) =>
          !value ||
          value.size < 5 * 1024 * 1024 ||
          "Carga debe pesar menos de 5 MB!"
      ],
      camposAdicionales: [] as string[],
      // variables de resultados
      loading: false,
      modoTest: true
    };
  },
  created() {
    this.loadCamposAdicionales();
  },
  methods: {
    loadCamposAdicionales() {
      CarreraService.getCarrera(String(this.carreraID))
        .then((carrera: any) => {
          if (Array.isArray(carrera?.camposAdicionales)) {
            this.camposAdicionales = carrera.camposAdicionales
              .map((campo: any) => String(campo?.nombre || "").trim())
              .filter((nombre: string) => Boolean(nombre));
          } else {
            this.camposAdicionales = [];
          }
        })
        .catch(() => {
          this.camposAdicionales = [];
        });
    },
    dialogChange(value: boolean) {
      this.$emit("dialogChange", value);
    },
    validate() {
      console.log(this.editedItem);
      //this.$refs.form.validate();
      const isValid = (this.$refs.form as Vue & {
        validate: () => boolean;
      }).validate();
      if (isValid) {
        this.save();
      }
    },
    close() {
      this.dialogChange(false);
    },
    save() {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        formData.append("file", this.files[i]);
      }

      formData.append("test", this.modoTest ? "1" : "0");
      formData.append("idCarrera", String(this.carreraID));

      this.loading = true;
      CarreraService.saveRegistroFromExcel(formData)
        .then(() => {
          this.close();
          this.$emit("saved", "someValue");
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 4000,
            icon: "success",
            title: "Registro from Excel",
            text: "Guardado exitosamente"
          });
        })
        .catch((error: AxiosError) => {
          let mensaje = "No se pudo guardar";
          if (error.response?.data && error.response.data.message) {
            mensaje = error.response.data.message;
          }
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 5000,
            icon: "error",
            title: "Registro from Excel",
            text: mensaje
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    /*
    (value: string) =>
          vali || "Debe ser una url valida como https://www.google.com"
          */
  },
  watch: {}
});
